import React, { useState } from 'react';
import { EntityAbility, EntityKind } from '../utils/entityAbilities';
import { GameDialog } from './GameDialog';
import './EntityDigitalCard.css';

export const getEntityArtworkPath = (kind: EntityKind, name: string, preview = false) =>
  `/${kind}s/rework/${preview ? 'small/' : ''}${encodeURIComponent(name)}.jpg`;

export function EntityDigitalCard({ kind, name, abilities }: {
  kind: EntityKind; name: string; abilities: EntityAbility[];
}) {
  const [previewFailed, setPreviewFailed] = useState(false);
  const [artworkFailed, setArtworkFailed] = useState(false);
  const [open, setOpen] = useState(false);
  return <article className="entity-digital-card" aria-label={`${name} ${kind}`}>
    <header className="entity-digital-heading"><span>{kind}</span><h3>{name}</h3></header>
    <div className="entity-digital-overview">
      <div className="entity-digital-portrait">
        {previewFailed ? <span className="entity-artwork-unavailable">Artwork unavailable</span> : <>
          <img src={getEntityArtworkPath(kind, name, true)} alt={`${name} artwork`}
            loading="lazy" decoding="async" width={240} height={160}
            onError={() => { setPreviewFailed(true); setOpen(false); }} />
          <button type="button" className="entity-artwork-open" aria-label={`View full artwork for ${name}`}
            aria-haspopup="dialog" onClick={() => { setArtworkFailed(false); setOpen(true); }}>
            <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" aria-hidden="true" focusable="false">
              <circle cx="10" cy="10" r="6" /><path d="m14.5 14.5 6 6" />
            </svg>
          </button>
        </>}
      </div>
      <div className="entity-digital-abilities">{abilities.map(ability => <section key={ability.title}>
        <h4>{ability.title}</h4><p>{ability.text}</p>
      </section>)}</div>
    </div>
    {open && <GameDialog title={`${name} artwork`} variant="artwork" onClose={() => setOpen(false)}>
      {artworkFailed ? <p role="alert">Artwork could not be loaded.</p> : <img className="entity-artwork-full"
        src={getEntityArtworkPath(kind, name)} alt={`${name} full artwork`} decoding="async" width={1200} height={800}
        onError={() => setArtworkFailed(true)} />}
    </GameDialog>}
  </article>;
}
